import { StyleSheet, Text, TouchableOpacity, View } from "react-native";

import { Avatar } from "react-native-elements";

import heroList from "../static/heros.json";
type HeroPanelProps = {
  id: string;
  size?: number;
  nameSize?: number;
  nameMaxWidth?: number;
  showName?: boolean;
  green?: boolean;
  red?: boolean;
  nameBottom?: boolean;
  onPress?: () => void
};

export const HeroPanel = ({
  id,
  showName = true,
  size = 40,
  nameSize= 20,
  nameMaxWidth = 300,
  green = false,
  onPress = () => {},
  nameBottom= false,
  red = false,
}: HeroPanelProps) => {
  const styles = StyleSheet.create({
    container: {
        display: 'flex',
      flexDirection: nameBottom ? "column": "row",
      alignItems: "center",
      justifyContent: showName ? "flex-start" : "center",

      //borderColor: green ? "green" : "red",
      // borderRadius: size/2,





      flex: 1
    },
    name: {
        fontFamily: 'NinjaTurtles',
        fontSize: nameSize,

        
    },
  });

  return (

    <View  style={styles.container}>
        
      <Avatar
        rounded
        size={size}
        containerStyle={{
              borderWidth: green || red ? 1 : 0,
          borderColor: green ? "green" : "red"
        }}
        iconStyle={{
            
        
        }}
        source={{
          uri: `https://storage.googleapis.com/counter-vision/characters/${id}.png`,
        }}
      />
      {showName && id ? (
        <Text style={styles.name}> {(heroList as any)[id].name}</Text>
      ) : null}
      </View>


    
    
  );
};
